/* eslint-disable */
import { createSelector } from 'reselect';
import ordersSelector from './Orders.selector';

/**
 * Select the orders loading selector
 * @returns {OrderEntity | null} The `order` that has been selected from the store
 */
const ordersLoadingSelector = createSelector(ordersSelector, (orders) => orders.loading);

export default ordersLoadingSelector;
